import AesUtil from "../../public/AesUtil";
import CryptoJS from "../../public/aes.js";
export const getEncryptedData = (key) => {
  var iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
  var salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
  var aesUtil = new AesUtil(128, 1000);

  var ciphertext = aesUtil.encrypt(
    salt,
    iv,
    process.env.VUE_APP__API_ENCRYP_SALT,
    key.toString()
  );

  var aesPassword = iv + "::" + salt + "::" + ciphertext;
  let encryptedData = btoa(aesPassword);
  return encryptedData;
};
export const getDecryptedData = (key) => {
  if(key) {
    var aesUtil = new AesUtil(128, 1000);
    const b64Decrypt = atob(key);
    const dArray = b64Decrypt.split("::");
    var text = aesUtil.decrypt(
      dArray[1],
      dArray[0],
      process.env.VUE_APP__API_ENCRYP_SALT,
      dArray[2].toString()
    );
    return text;
  }
};